/**
 * "Não uso isto": a empresa dispensa NF-e, boletos ou o DinaBox (ADR-0104).
 *
 * O motivo é obrigatório e fica na auditoria junto de quem dispensou; o
 * item passa a contar para os 100% e dá para desfazer na própria lista.
 * Erro do servidor aparece aqui dentro, junto do campo.
 */
import React, { useEffect, useRef, useState } from "react";

import AsyncButton from "../../components/AsyncButton";
import { useAuth } from "../../context/AuthContext";
import useCliqueFora from "../../hooks/useCliqueFora";
import { dispensarItem } from "../../services/onboarding";

const TAMANHO_MOTIVO = 200;

export default function DialogoNaoUsoIsto({ item, onFechar, onDispensado }) {
  const { request } = useAuth();
  const [motivo, setMotivo] = useState("");
  const [erro, setErro] = useState("");
  const campoRef = useRef(null);
  const cliqueFora = useCliqueFora(onFechar);

  useEffect(() => {
    campoRef.current?.focus();
    const aoTeclar = (e) => {
      if (e.key === "Escape") onFechar();
    };
    document.addEventListener("keydown", aoTeclar);
    return () => document.removeEventListener("keydown", aoTeclar);
  }, [onFechar]);

  const confirmar = async () => {
    setErro("");
    try {
      onDispensado(await dispensarItem(request, item.chave, motivo.trim()));
    } catch (err) {
      setErro(err?.message || "Não foi possível dispensar agora.");
      throw err;
    }
  };

  return (
    <div className="onb-dialogo-veu">
      <div
        className="onb-dialogo"
        role="dialog"
        aria-modal="true"
        aria-labelledby="onb-dialogo-titulo"
        aria-describedby="onb-dialogo-texto"
        {...cliqueFora}
      >
        <h3 id="onb-dialogo-titulo">A empresa não usa: {item.titulo}?</h3>
        <p id="onb-dialogo-texto">
          O item sai da conta dos 100%. Fica registrado quem marcou e por quê, e dá para desfazer a
          qualquer momento na própria lista.
        </p>
        <label htmlFor="onb-motivo">Por que a empresa não usa? (obrigatório)</label>
        <textarea
          id="onb-motivo"
          ref={campoRef}
          value={motivo}
          maxLength={TAMANHO_MOTIVO}
          placeholder="Ex.: a nota é emitida pelo contador."
          onChange={(e) => setMotivo(e.target.value)}
        />
        <div className="onb-dialogo__conta" aria-hidden="true">
          {motivo.length}/{TAMANHO_MOTIVO}
        </div>
        {erro && (
          <div className="onb-dialogo__erro" role="alert">
            {erro}
          </div>
        )}
        <div className="onb-dialogo__botoes">
          <button type="button" className="onb-btn" onClick={onFechar}>
            Cancelar
          </button>
          <AsyncButton
            onClick={confirmar}
            disabled={!motivo.trim()}
            silentError
            successMessage="Pronto: o item conta como resolvido."
          >
            Não uso isto
          </AsyncButton>
        </div>
      </div>
    </div>
  );
}
